<template>
  <div class="px-2">
    <div class="d-flex align-items-end"
         :class="{ 'justify-content-between': lista.length && !propWizard,
                   'justify-content-end': !lista.length || propWizard }">
      <div v-if="lista.length && !propWizard"
           class="form-group">
        <label class="label"
               for="searchUser">Buscar Usuário</label>
        <input id="searchUser"
               v-model="searchUser"
               class="form-control form-control-sm"
               name="searchUser"
               placeholder="Ex: Zé da Silva"
               type="search"
               @change="filterList">
      </div>

      <div class="d-inline-block mb-4 mt-2">
        <button class="btn btn-sm btn-primary"
                type="button"
                @click="edicao= false; showModal = true">
          Adicionar
        </button>
      </div>
    </div>

    <div v-if="lista.length"
         class="responsive-table">
      <b-table class="mb-2 table--headVariation"
               sticky-header
               thead-class="thead--green"
               bordered
               hover
               :items="filterList"
               :fields="fields"
               :small="true">
        <template slot="ativo"
                  slot-scope="data">
          <span class="">{{ (data.item.ativo === 1) ? 'Sim' : 'Não' }}</span>
        </template>

        <template slot="oficial"
                  slot-scope="data">
          <span class="">{{ (data.item.flag_oficial === 1) ? 'Sim' : 'Não' }}</span>
        </template>

        <template slot="escrevente"
                  slot-scope="data">
          <span class="">{{ (data.item.escrevente === 1) ? 'Sim' : 'Não' }}</span>
        </template>

        <template slot="excluir"
                  slot-scope="data">
          <div class="d-block text-center">
            <button class="btn btn--xs btn-primary mr-2"
                    title="Editar usuário"
                    type="button"
                    @click="editUser(data.item)">
              <svg class="icon icon--xxs icon--clearFill"
                   role="presentation">
                <use :xlink:href="'#' + edit.id" />
              </svg>
            </button>

            <button class="btn btn--xs btn-danger"
                    title="Deletar usuário"
                    type="button"
                    :disabled="!!data.item.flag_oficial"
                    @click="deletarUsuario(data.item)">
              <svg class="icon icon--xxs icon--clearFill"
                   role="presentation">
                <use :xlink:href="'#' + trash.id" />
              </svg>
            </button>
          </div>
        </template>
      </b-table>
    </div>

    <p v-else
       class="text--return border border-primary text-center rounded">
      Sem Usuários cadastrados.
    </p>

    <b-modal v-if="showModal"
             id="modalAddUsuario"
             modal-class="customModal"
             body-class="customModal_body"
             header-class="customModal_header"
             title-class="customModal_header_title"
             footer-class="customModal_footer"
             centered
             visible
             :title="!edicao ? 'Adicionar usuário' : 'Editar usuário'"
             size="lg"
             @show="openModal"
             @hide="closeModal">
      <form autocomplete="off"
            name="modalAddUsuario"
            novalidate>
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="nomeUsuario">Nome</label>
              <input id="nomeUsuario"
                     v-model="formData.nome"
                     v-validate="'required|min:4'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('nomeUsuario') }"
                     minlength="6"
                     name="nomeUsuario"
                     required
                     placeholder="Ex: José Dantas"
                     type="text">
              <small v-if="errors.has('nomeUsuario')"
                     class="invalid-feedback">{{ errors.first('nomeUsuario') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="loginUsuario">Login</label>
              <input id="loginUsuario"
                     v-model="formData.login"
                     v-validate="'required|min:4'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('loginUsuario') }"
                     name="loginUsuario"
                     minlength="4"
                     required
                     placeholder="Ex: joseDantas69"
                     type="text">
              <small v-if="errors.has('loginUsuario')"
                     class="invalid-feedback">{{ errors.first('loginUsuario') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="emailUsuario">E-mail</label>
              <input id="emailUsuario"
                     v-model="formData.email"
                     v-validate="'required|email'"
                     autocomplete="on"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('emailUsuario') }"
                     name="emailUsuario"
                     placeholder="jose.dantas@gmail.com"
                     required
                     type="email">
              <small v-if="errors.has('emailUsuario')"
                     class="invalid-feedback">{{ errors.first('emailUsuario') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="usuarioSenha"
                     class="label">Senha</label>
              <input v-if="edicao"
                     id="usuarioSenha"
                     ref="novaSenha"
                     v-model="formData.senha"
                     autocomplete="on"
                     data-vv-name="usuarioSenha"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('usuarioSenha') || ((formData.senha != formData.confirmSenha) && formData.confirmSenha.length > 0) }"
                     minlength="4"
                     name="usuarioSenha"
                     placeholder="* * * * * *"
                     required
                     type="password">
              <input v-if="!edicao"
                     id="usuarioSenha"
                     ref="novaSenha"
                     v-model="formData.senha"
                     v-validate="'required|min:4'"
                     autocomplete="on"
                     data-vv-name="usuarioSenha"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('usuarioSenha') }"
                     minlength="4"
                     name="usuarioSenha"
                     placeholder="* * * * * *"
                     required
                     type="password">
              <small v-if="errors.has('usuarioSenha')"
                     class="invalid-feedback"> {{ errors.first('usuarioSenha') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label class="label"
                     for="confirmaSenhaUsuario">Confirmar Senha</label>
              <input v-if="edicao"
                     id="confirmaSenhaUsuario"
                     v-model="formData.confirmSenha"
                     autocomplete="on"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('confirmaSenhaUsuario') || ((formData.senha != formData.confirmSenha) && formData.confirmSenha.length > 0) }"
                     data-vv-rules="confirmed:usuarioSenha"
                     data-vv-name="confirmaSenhaUsuario"
                     data-vv-as="novaSenha"
                     name="confirmaSenhaUsuario"
                     placeholder="* * * * * *"
                     required
                     type="password">
              <input v-if="!edicao"
                     id="confirmaSenhaUsuario"
                     v-model="formData.confirmSenha"
                     v-validate="'required|confirmed:novaSenha'"
                     autocomplete="on"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('confirmaSenhaUsuario') }"
                     data-vv-rules="confirmed:usuarioSenha"
                     data-vv-name="confirmaSenhaUsuario"
                     data-vv-as="novaSenha"
                     name="confirmaSenhaUsuario"
                     placeholder="* * * * * *"
                     required
                     type="password">
              <small v-if="errors.has('confirmaSenhaUsuario')"
                     class="invalid-feedback">{{ errors.first('confirmaSenhaUsuario') }}</small>
              <small v-if="(formData.senha != formData.confirmSenha) && formData.confirmSenha.length > 0"
                     class="invalid-feedback">As senhas precisam ser iguais</small>
            </div>
          </div>

          <div class="col-12 col-sm-5 col-xl-3">
            <div class="form-group">
              <label class="label"
                     for="cpfUsuario">CPF</label>
              <input id="cpfUsuario"
                     v-model="formData.cpf"
                     v-mask.lazy="`###.###.###-##`"
                     v-validate="'required'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('cpfUsuario') }"
                     name="cpfUsuario"
                     placeholder="000.000.000-00"
                     required
                     type="text">
              <small v-if="errors.has('cpfUsuario')"
                     class="invalid-feedback">{{ errors.first('cpfUsuario') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="cargoUsuario">Cargo</label>
              <input id="cargoUsuario"
                     v-model="formData.cargo"
                     v-validate="'required'"
                     :class="{ 'is-invalid': errors.has('cargoUsuario') }"
                     class="form-control form-control-sm"
                     name="cargoUsuario"
                     placeholder="Ex: Front-end Developer"
                     required
                     type="text">
              <small v-if="errors.has('cargoUsuario')"
                     class="invalid-feedback">{{ errors.first('cargoUsuario') }}</small>
            </div>
          </div>

          <div class="col-12 col-sm-4">
            <div class="form-group">
              <label class="label"
                     for="grupoAcesso">Grupo de Acesso</label>
              <select id="grupoAcesso"
                      v-model="formData.groups"
                      v-validate="'required'"
                      :class="{ 'is-invalid': errors.has('grupoAcesso') }"
                      class="custom-select custom-select-sm"
                      name="grupoAcesso"
                      required>
                <option value=""
                        selected>
                  Selecione
                </option>
                <option v-for="(group, ind) in listGroups"
                        :key="ind"
                        :disabled="group.ativo !== 1"
                        :value="group.group_id">
                  {{ group.name }}
                </option>
              </select>
              <small v-if="errors.has('grupoAcesso')"
                     class="invalid-feedback">{{ errors.first('grupoAcesso') }}</small>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="label"
                     for="cartorio">Cartório</label>
              <select id="cartorio"
                      v-model="formData.cartorio_id"
                      v-validate="'required'"
                      :class="{ 'is-invalid': errors.has('cartorio') }"
                      disabled
                      class="custom-select custom-select-sm"
                      name="cartorio"
                      required>
                <option value=""
                        selected>
                  Selecione
                </option>
                <option v-for="(cartorio, ind) in listCartorios"
                        :key="ind"
                        :value="cartorio.cartorio_id">
                  {{ cartorio.nome }}
                </option>
              </select>
              <small v-if="errors.has('cartorio')"
                     class="invalid-feedback">{{ errors.first('cartorio') }}</small>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group">
              <span class="custom-control custom-switch custom-control-inline">
                <input id="usuarioAtivo"
                       v-model="formData.ativo"
                       class="custom-control-input"
                       name="usuarioAtivo"
                       required
                       :disabled="formData.user_id && !!formData.flag_oficial"
                       type="checkbox">
                <label class="custom-control-label"
                       for="usuarioAtivo">Ativo</label>
              </span>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group">
              <span class="custom-control custom-switch custom-control-inline">
                <input id="usuarioOficial"
                       v-model="formData.flag_oficial"
                       class="custom-control-input"
                       name="usuarioOficial"
                       required
                       :disabled="(formData.user_id && !!formData.flag_oficial) || oficiais.length >= 1"
                       type="checkbox">
                <label class="custom-control-label"
                       for="usuarioOficial">Oficial</label>
              </span>
            </div>
          </div>

          <div class="col-auto">
            <div class="form-group">
              <span class="custom-control custom-switch custom-control-inline">
                <input id="usuarioEscrevente"
                       v-model="formData.escrevente"
                       class="custom-control-input"
                       name="usuarioOficial"
                       required
                       :disabled="formData.user_id && !!formData.flag_oficial"
                       type="checkbox">
                <label class="custom-control-label"
                       for="usuarioEscrevente">Escrevente</label>
              </span>
            </div>
          </div>
        </div>
      </form>
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <div class="row no-gutters justify-content-end align-items-center">
          <button class="btn btn-sm btn-dark mr-2"
                  @click="cancel()">
            Voltar
          </button>
          <button class="btn btn-sm btn-primary"
                  type="button"
                  @click="addEditUsuario()">
            {{ edicao ? 'Editar usuário' : 'Adicionar' }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import trash from '@/assets/icons/delete.svg?sprite'
  import edit from '@/assets/icons/pencil.svg?sprite'
  import objSwal from '@/constants/swalValues'
  import Swal from 'sweetalert2'

  /* services */
  import UsuarioService from "@/services/Auth/UsuarioService"
  import CartorioService from "@/services/CartorioService"
  import AccessGroupsService from '@/services/Auth/AccessGroupsService'

  /* libraries */
  import { mapGetters } from "vuex"

  export default {
    name: 'UsuariosServentia',
    props: {
      tabActive: Number,
      propWizard: {type: Boolean, default: false},
      propPasso: { type: Number, default: null }
    },
    data () {
      return {
        showModal: false,
        edit,
        trash,
        searchUser: '',
        indeterminate: true,
        listGroups: [],
        listCartorios: [],
        formData: {
          cartorio_id: null,
          ativo: 0,
          escrevente: 0,
          flag_oficial: 0,
          nome: '',
          cpf: '',
          cargo: '',
          email: '',
          login: '',
          senha: '',
          confirmSenha: '',
          groups: ''
        },
        edicao: false,
        lista: [],
        oficiais: [],
        fields: [{
          key: 'nome',
          label: 'Nome',
          sortable: true
        }, {
          key: 'ativo',
          label: 'Ativo',
          sortable: true
        }, {
          key: 'oficial',
          label: 'Oficial',
          sortable: true
        }, {
          key: 'escrevente',
          label: 'Escrevente',
          sortable: true
        }, {
          key: 'groups[0].name',
          label: 'Grupo',
          sortable: true
        }, {
          key: 'excluir',
          label: 'Ações',
          sortable: false
        }],
      }
    },
    computed: {
      ...mapGetters({
        cartorioObj: 'auth/getCartorioObj'
      }),

      filterList () {
        if (!this.searchUser.length) return this.lista

        return this.lista.filter(val => {
          let search = JSON.stringify(val).toLowerCase()
          if (search.includes(this.searchUser.toLowerCase())) return val
        })
      }
    },
    watch: {
      tabActive () {
        if (this.tabActive == 1) {
          this.callUsersData()
        }
      },
      lista () {
        if (this.propWizard) this.$emit('changed', this.lista)
      },
      propPasso () {
        if (this.propPasso && this.propPasso === 2) {
          this.callUsersData()
        }
      }
    },
    beforeMount () {
      this.callUsersData()
    },
    methods: {
      async callUsersData () {
        loader({ text: 'Buscando dados...', active: true })

        await CartorioService.getCartoriosRei()
          .then((res) => this.listCartorios = res.data)

        await AccessGroupsService.indexAcessGroups()
          .then((res) => this.listGroups = res)

        await UsuarioService.getUsuarios()
          .then(res => this.lista = res.data)
          .finally(() => loader({ text: "", active: false }))

        this.lista = this.lista.filter((user) => {
          if (user.nome.match('SUPORTE') || user.nome.match('suporte')) return false
          return user.cartorio_id === this.cartorioObj.cartorio_id
        })

        this.oficiais = this.lista.filter( usuario => usuario.flag_oficial == 1 && usuario.ativo == 1)
      },
      editUser (user) {
        this.edicao = true
        this.showModal = true
        delete user.senha
        this.formData = { ...this.formData, ...user, groups: user.groups && user.groups.length ? user.groups[0].group_id : "" , cartorio_id: user.cartorio_id}
      },
      openModal () {
        this.errors.clear()
        this.formData.cartorio_id = this.cartorioObj.cartorio_id
      },
      closeModal () {
        this.showModal = false
        this.edicao = false
        this.formData = {
          ativo: 1,
          escrevente: 0,
          flag_oficial: 0,
          nome: '',
          cpf: '',
          cargo: '',
          email: '',
          login: '',
          senha: '',
          confirmSenha: '',
          cartorio_id: this.cartorioObj && this.cartorioObj.cartorio_id
        }
      },
      deletarUsuario (val) {
        if (val.flag_oficial) {
          return this.onError('', 'O oficial não pode ser excluído.')
        }

        objSwal.question.title = "Atenção!"
        objSwal.question.text = "Tem Certeza que deseja excluir este usuário e todos seus dados?"

        Swal.fire(objSwal.question).then(res => {
          if (!res.value) return

          loader({ text: 'Deletando dados...', active: true })

          return UsuarioService.deleteUsuario(val).then(resp => {
            objSwal.success.title = 'Usuário excluído'
            objSwal.success.text = ''

            return Swal.fire(objSwal.success).then(res => this.callUsersData())
          })
        }).catch((e) => {
          this.onError(`Erro ao deletar usuário.`, e.response.data.message)
        }).finally(() => loader({ text: '', active: false }))
      },
      addEditUsuario () {
        let text = (this.edicao) ? 'Usuário atualizado!' : 'Usuário adicionado!'
        let objEnvio = { ...this.formData, groups: [this.formData.groups] }

        !objEnvio.senha && delete objEnvio.senha
        !objEnvio.confirmSenha && delete objEnvio.confirmSenha

        loader({ text: 'Enviando dados...', active: true })

        this.$validator.validateAll().then(res => {
          if (!res) {
            return loader({ text: '', active: false })
          }

          let errorOccurred = false

          return (this.edicao ? UsuarioService.updateUsuario(objEnvio) : UsuarioService.addUsuario(objEnvio)).then(() => {
            objSwal.success.title = text
            objSwal.success.text = ''
            this.closeModal()
            return Swal.fire(objSwal.success).then(() => this.callUsersData())
          }).catch((e) => {
            errorOccurred = true

            if (e.response.data.error && e.response.data.error.message.match(/.*users_cpf_unique.*/)) {
              const duplicate = e.response.data.error.message.match(/Duplicate entry (.*)/)[1]
              const cpf = duplicate.split(' ')[0]
              return this.onError(`Erro ao ${this.edicao ? 'editar' : 'cadastrar'} usuário.`, `Já existe um usuário cadastrado com o cpf ${cpf}`)
            } else if (e.response.data.length) {
              // erros validator
              // TODO: depois pensar em um helper

              const erros = []
              const msgErros = {
                unique: "':field' do usuário com o valor ':value' já cadastrado."
              }

              let html = []

              e.response.data.forEach(err => {
                html.push(msgErros[err.validation].replace(':field', err.field).replace(':value', this.formData[err.field]))
              })

              objSwal.error.title = 'Erro ao cadastrar usuário'
              objSwal.error.html = html.join('<br>')

              Swal.fire(objSwal.error).finally(() => objSwal.error.html = '')
            } else {
              return this.onError(`Erro ao ${this.edicao ? 'editar' : 'cadastrar'} usuário.`, e.response.data.message || e.message)
            }
          }).finally(() => {
            loader({ text: '', active: false })
            if (!errorOccurred) {
              this.closeModal()
            }
          })
        })
      },
      onError (title = 'Erro', text = '') {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = ''

        return Swal.fire(objSwal.error)
      },
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .table {
    &--headVariation {}
  }
</style>
